import Vue from "vue";
import App from "./App.vue";
import VueI18n from "vue-i18n";
import LoadScript from "vue-plugin-load-script";
import axios from 'axios';
import VueAxios from 'vue-axios'
import mixin from "./mixins/mixin";

import "@/assets/css/bootstrap.css";
import "@/assets/style.css";
import "@/assets/css/dark.css";
import "@/assets/css/font-icons.css";

import "@/assets/css/one-page/et-line.css";
import "@/assets/css/animate.css";
import "@/assets/css/magnific-popup.css";
import "@/assets/css/responsive.css";

import "@/assets/coworking/css/fonts.css";
import "@/assets/coworking/coworking.css";
import "@/assets/css/gym-twentytwenty.css";

import "@/assets/css/color.css";
import "@/assets/css/custom.css";

import VModal from 'vue-js-modal'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import i18n from './i18n'
import router from './router'
import VueGtag from "vue-gtag";


Vue.config.productionTip = false;

Vue.use(LoadScript);
Vue.use(VueI18n);
Vue.use(VModal);
Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
Vue.use(VueGtag, {
  config: { id: "UA-72419014-1" }
});



Vue.loadScript("//www.forhair.co.kr/assets/landing/js/jquery.js").then(() => {
  Vue.loadScript("//www.forhair.co.kr/assets/landing/js/plugins.js").then(() => {
    Vue.loadScript("//www.forhair.co.kr/assets/landing/js/functions.js");
  });
});

new Vue({
  mixins: [mixin],
  i18n,
  router,
  render: h => h(App)
}).$mount("#app");

